const isUndefined = require('lodash/isUndefined');
function formatToBrCurrency(cash, prefix) {
  cash = parseFloat(cash);

  prefix = isUndefined(prefix) || prefix ? 'R$ ' : '';

  if (isNaN(cash)) {
    return '0,00';
  }

  cash = cash.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2
  })
    .replace('R$', '');

  return prefix + cash;
}

module.exports = formatToBrCurrency;
